import { Routes, Route, Navigate } from 'react-router-dom'
import Gallery from './pages/Gallery'
import Studio from './pages/Studio'

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Gallery />} />
      <Route path="/s/:sceneId" element={<Studio />} />
      <Route path="/p/:projectId" element={<Studio />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
